import { useEffect, useState } from "react";

// Launch: 07.10.2026, 06:00 Uhr deutsche Zeit (CEST = UTC+2)
export const LAUNCH_AT = new Date("2026-10-07T06:00:00+02:00");

const isPreview = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get("preview") === "1") {
    window.localStorage.setItem("bs_preview", "1");
    return true;
  }
  if (params.get("preview") === "0") {
    window.localStorage.removeItem("bs_preview");
    return false;
  }
  return window.localStorage.getItem("bs_preview") === "1";
};

export const useLaunchGate = () => {
  const [locked, setLocked] = useState(() => Date.now() < LAUNCH_AT.getTime() && !isPreview());

  useEffect(() => {
    if (!locked) return;
    const id = setInterval(() => {
      if (Date.now() >= LAUNCH_AT.getTime()) setLocked(false);
    }, 1000);
    return () => clearInterval(id);
  }, [locked]);

  return locked;
};

export const useCountdown = (target = LAUNCH_AT) => {
  const diff = () => Math.max(0, target.getTime() - Date.now());
  const [ms, setMs] = useState(diff);

  useEffect(() => {
    const id = setInterval(() => setMs(diff()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);

  const total = Math.floor(ms / 1000);
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
  };
};
